export default {"src":"/_next/static/media/cross-svgrepo-com.0802e8c5.svg","height":490,"width":490};